import React from 'react';
import { Box, Typography } from '@mui/material';

export interface BadgeProps {
  label: string;
  icon?: string;
  pulse?: boolean;
}

export const Badge: React.FC<BadgeProps> = ({ label, icon, pulse = false }) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        borderRadius: 50,
        backgroundColor: 'rgba(0, 102, 255, 0.1)',
        border: '1px solid rgba(0, 102, 255, 0.25)',
        width: 'fit-content',
      }}
    >
      {pulse && (
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: '#0066ff',
            boxShadow: '0 0 10px #0066ff',
          }}
        />
      )}
      {icon && (
        <span
          className="material-symbols-outlined"
          style={{ fontSize: 16, color: '#0066ff' }}
        >
          {icon}
        </span>
      )}
      <Typography
        variant="caption"
        sx={{
          color: '#0066ff',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          fontFamily: 'Inter',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default Badge;
